import { ProductHub } from "./ProductHub";
import { games } from "./data/products";

export const GamesPage: React.FC = () => {
  return (
    <ProductHub
      eyebrow="Games"
      heading={
        games.length === 1
          ? "One game, built the same way as everything else here."
          : `${games.length} games, built the same way as everything else here.`
      }
      lede="Small games that are actually about something — built to behave like the thing they are imitating rather than merely to look like it."
      products={games}
      cta="View game"
    />
  );
};
